import * as ng from 'angular';
import {ArchiSmallServices} from '../../../../services/archismall.service';

interface IData {
  piva: string;
  idpdv: string;
}

class ControlloIntegritaController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    'ArchiSmallServices',
    '$uibModal',
    '$state',
  ];

  constructor(
    private $scope: {
      data: IData,
      // serve per evitare errori di typescript su parametri non definiti, di default ogni parametro è any
      [key: string]: any
    },
    private $rootScope: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private $state: any,
  ) {
    $scope.pageHeader = 'Controllo Integrità';
    $scope.PIVAType = new RegExp('^[0-9]{11}$');

    $scope.integrityCheck = (data: IData) => {
      let CreateModal = $uibModal.open({
        animation: true,
        component: 'controlloIntegritaModalComponent',
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          settings: () => {
            return {
              user: $rootScope.currentUser().sub,
              idpdv: data.idpdv,
              piva: data.piva,
            };
          }
        }
      });
      CreateModal.result.catch(error => {
        console.error('Error:', error);
      })
        .finally(() => {
          $state.reload();
        });
    };
  }
}

export const ControlloIntegritaComponent: ng.IComponentOptions = {
  template: require('./controllo-integrita.html'),
  controller: ControlloIntegritaController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/controllo-integrita/controllo-integrita.ts